import React, { memo } from 'react';
import { format } from 'date-fns';


var FieldInfo = function (_a) {
    var type = _a.type, value = _a.value;
    return (React.createElement("p", { className: 'field-info value' }, type ? "(" + type + ") - " + value : value));
};
var IdentityDetails = function (_a) {
    var _b, _c, _d;
    var identity = _a.identity;
    return (React.createElement("div", { className: 'IdentityDetails pluggy' },
        React.createElement("div", { className: 'grid' },
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'column' },
                    React.createElement("p", { className: 'column-header' }, "N\u00FAmero de identifica\u00E7\u00E3o fiscal"),
                    React.createElement("p", { className: 'value' }, (_b = identity.taxNumber) !== null && _b !== void 0 ? _b : '-')),
                React.createElement("div", { className: 'column' },
                    React.createElement("p", { className: 'column-header' }, "Data de nascimento"),
                    React.createElement("p", { className: 'value' }, identity.birthDate !== null
                        ? format(new Date(identity.birthDate), 'dd/MM/yyyy')
                        : '-')),
                React.createElement("div", { className: 'column' },
                    React.createElement("p", { className: 'column-header' }, "Cargo"),
                    React.createElement("p", { className: 'value' }, (_c = identity.jobTitle) !== null && _c !== void 0 ? _c : '-')))),
        React.createElement("div", { className: 'grid' },
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'column' },
                    React.createElement("p", { className: 'column-header' }, "Endere\u00E7os"),
                    identity.addresses && identity.addresses.length > 0
                        ? identity.addresses.map(function (address) { return (React.createElement(FieldInfo, { value: address.fullAddress, type: address.type, key: address.fullAddress })); })
                        : '-'),
                React.createElement("div", { className: 'column' },
                    React.createElement("p", { className: 'column-header' }, "N\u00FAmero de telefone"),
                    identity.phoneNumbers && identity.phoneNumbers.length > 0
                        ? identity.phoneNumbers.map(function (phoneNumber) { return (React.createElement(FieldInfo, { value: phoneNumber.value, type: phoneNumber.type, key: phoneNumber.value })); })
                        : '-'),
                React.createElement("div", { className: 'column' },
                    React.createElement("p", { className: 'column-header' }, "E-mail"),
                    identity.emails && identity.emails.length > 0
                        ? identity.emails.map(function (email) { return (React.createElement(FieldInfo, { value: email.value, type: email.type, key: email.value })); })
                        : '-'))),
        React.createElement("div", { className: 'grid' },
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'column' },
                    React.createElement("p", { className: 'column-header' }, "Rela\u00E7\u00F5es"),
                    identity.relations && identity.relations.length > 0
                        ? identity.relations.map(function (relation) { return (React.createElement(FieldInfo, { value: relation.name, type: relation.type, key: relation.name })); })
                        : '-'),
                React.createElement("div", { className: 'column' },
                    React.createElement("p", { className: 'column-header' }, "Perfil do Investidor"),
                    React.createElement("p", { className: 'value' }, (_d = identity.investorProfile) !== null && _d !== void 0 ? _d : '-')),
                React.createElement("div", { className: 'column' })))));
};
export default memo(IdentityDetails);
